// File: src/pages/LoginPage.js
// This page is updated to handle login submissions to the backend.
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('/api/login', { email, password });
      // On success, save the token and redirect to the admin dashboard
      localStorage.setItem('authToken', response.data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-black p-8 md:p-12 rounded-lg shadow-lg w-full max-w-md border-t-4 border-lime">
        <div className="text-center mb-8">
          <Link to="/">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-16 w-auto mx-auto mb-4" />
          </Link>
          <h2 className="text-3xl font-bold text-white">Welcome Back</h2>
          <p className="text-gray-400">Login to continue your journey</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="email">
              Email Address
            </label>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-lime"
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
             <div className="flex justify-between items-center mb-2">
                <label className="block text-gray-400 text-sm font-bold" htmlFor="password">
                    Password
                </label>
                <button type="button" className="text-sm text-lime hover:underline bg-transparent border-none">Forgot Password?</button>
             </div>
            <input
              className="appearance-none block w-full bg-gray-800 text-white border border-gray-700 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-lime"
              id="password"
              type="password"
              placeholder="******************"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-red-500 text-xs italic text-center mb-4">{error}</p>}
          <div className="mb-6">
            <button className="w-full bg-lime text-black font-bold py-3 px-4 rounded-lg hover:bg-opacity-80 transition duration-300 glow-lime" type="submit">
              Login
            </button>
          </div>
          <p className="text-center text-gray-400">
            Don't have an account? <Link to="/signup" className="text-magenta font-bold hover:underline">Sign Up</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
